<template>
    <h3 class="question text-bold"
        :style="{color: rgbaToCss(dataColor)}">
        {{dataHeading}}
    </h3>
</template>

<script>
    import rgbaToCss from '@mixins/rgba-to-css'

    export default {
        props: {
            dataHeading: {
                type: String,
            },
            dataColor: {
                type: Object,
            },
        },

        mixins: [rgbaToCss]
    }
</script>

<style scoped>
    .question{
        word-wrap: break-word;
    }
</style>
